export default __webpack_public_path__ + "static/media/icon-chevron-right.ce1805c6.svg";